import LocaleProvider from "antd/lib/locale-provider";
import React from "react";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";

const themes = {
  dark: `${process.env.PUBLIC_URL}/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/light-theme.css`,
};

const prevTheme = window.localStorage.getItem("theme");

ReactDOM.render(
  <LocaleProvider>
    <ThemeSwitcherProvider themeMap={themes} defaultTheme={prevTheme || "dark"}>
      <App />
    </ThemeSwitcherProvider>
  </LocaleProvider>,
  document.getElementById("root"),
);
